export default __webpack_public_path__ + "static/media/erase.2ee9589a.svg";